/**
 * Заявки правок эфира — из опроса прогресса эфира (StreamProgress, `/progress` раз в 5 с) тем, кому нужен их ход вне
 * окна прогресса: дорожка озвучки держит своё перетащенное место, пока заявка этой правки не закончилась
 * (providers/AudioProvider/savedTimingPins, проба P50m20g, E7). Один источник — опрос; подписчиков сколько угодно.
 */
import type { TimingFixLike } from "providers/AudioProvider/savedTimingPins";

type Listener = (fixes: TimingFixLike[]) => void;

const listeners = new Set<Listener>();

/** Новые заявки эфира с опроса прогресса — всем подписчикам. */
export function publishStreamFixes(fixes: TimingFixLike[]): void {
    listeners.forEach((listener) => {
        try {
            listener(fixes);
        } catch (error) {
            console.error("[streamFixFeed] listener failed", error);
        }
    });
}

/** Подписаться на заявки эфира. -> отписка. */
export function subscribeStreamFixes(listener: Listener): () => void {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
}
